// extracted by mini-css-extract-plugin
module.exports = {"spinnerOverlay":"with-spinner_spinnerOverlay__U0Z2P","spinnerContainer":"with-spinner_spinnerContainer__XBpQy","spin":"with-spinner_spin__3m5yh"};